module.exports = __webpack_public_path__ + "static/img/1694_phase_function_Paper_PointsHejduk_Prediction.da22cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1694_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Z/qZ
// module chunks = 0